import { render, staticRenderFns } from "./BookFormInfo.vue?vue&type=template&id=c507f844&scoped=true&"
import script from "./BookFormInfo.vue?vue&type=script&lang=ts&"
export * from "./BookFormInfo.vue?vue&type=script&lang=ts&"
import style0 from "./BookFormInfo.vue?vue&type=style&index=0&id=c507f844&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c507f844",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
